import type { ISearchIcon } from './helpers';

export const SearchIcon = ({ variant = 'default', ...rest }: ISearchIcon) => {
	if (variant === 'default')
		return (
			<svg
				width='14'
				height='14'
				viewBox='0 0 14 14'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M13.3539 12.6464L10.2245 9.51764C11.1315 8.42871 11.5838 7.03201 11.4873 5.6181C11.3908 4.20419 10.7528 2.88193 9.70623 1.92637C8.65963 0.970822 7.28492 0.455551 5.86808 0.487751C4.45125 0.519951 3.10137 1.09714 2.09926 2.09926C1.09714 3.10137 0.519951 4.45125 0.487751 5.86808C0.455551 7.28492 0.970822 8.65963 1.92637 9.70623C2.88193 10.7528 4.20419 11.3908 5.6181 11.4873C7.03201 11.5838 8.42871 11.1315 9.51764 10.2245L12.6464 13.3539C12.6928 13.4003 12.748 13.4372 12.8087 13.4623C12.8694 13.4875 12.9344 13.5004 13.0001 13.5004C13.0658 13.5004 13.1309 13.4875 13.1916 13.4623C13.2523 13.4372 13.3074 13.4003 13.3539 13.3539C13.4003 13.3074 13.4372 13.2523 13.4623 13.1916C13.4875 13.1309 13.5004 13.0658 13.5004 13.0001C13.5004 12.9344 13.4875 12.8694 13.4623 12.8087C13.4372 12.748 13.4003 12.6928 13.3539 12.6464ZM1.50014 6.00014C1.50014 5.11013 1.76406 4.2401 2.25853 3.50008C2.753 2.76006 3.4558 2.18328 4.27807 1.84268C5.10033 1.50209 6.00513 1.41298 6.87805 1.58661C7.75096 1.76024 8.55279 2.18883 9.18212 2.81816C9.81146 3.4475 10.24 4.24932 10.4137 5.12224C10.5873 5.99515 10.4982 6.89995 10.1576 7.72222C9.81701 8.54449 9.24023 9.24729 8.50021 9.74176C7.76019 10.2362 6.89016 10.5001 6.00014 10.5001C4.80707 10.4988 3.66325 10.0243 2.81962 9.18066C1.976 8.33704 1.50147 7.19321 1.50014 6.00014Z'
					fill='var(--color-primary-200)'
				/>
			</svg>
		);

	return (
		<svg
			width='20'
			height='21'
			viewBox='0 0 20 21'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<path
				d='M17.5 17.6914L14.5834 14.7747M16.6667 9.77474C16.6667 13.6868 13.4954 16.8581 9.58333 16.8581C5.67132 16.8581 2.5 13.6868 2.5 9.77474C2.5 5.86272 5.67132 2.69141 9.58333 2.69141C13.4954 2.69141 16.6667 5.86272 16.6667 9.77474Z'
				stroke='#566F83'
				strokeWidth='1.66667'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};
